import { generatePath, Route, Switch } from "react-router-dom";

import LogoutIcon from "@/assets/icons/logout.svg";
import Layout from "@/containers/Layout";
import { useOrganization } from "@/hooks/useOrganization";
import { ROUTES } from "@/routes_new";
import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";
import Button from "@components/Button";
import Container from "@components/Container";
import Rhythm from "@components/Rhythm";
import { TabLink, TabNavigation } from "@components/Tabs";
import Typography from "@components/Typography";

import AccountView from "./account";
import ProfileView from "./profile";
import UsersView from "./users";

import styles from "./SettingsView.module.css";

export type SettingsViewProps = { className?: string };

const SettingsView: React.FunctionComponent<SettingsViewProps> = () => {
  const { data: orgData } = useOrganization();
  const { uuid: orgUuid = null } = orgData?.ok ? orgData.data : {};

  if (!orgUuid) return null;

  return (
    <Layout>
      <Container>
        <Rhythm className={styles.header}>
          <Typography variant="h1">{L.SETTINGS_TITLE}</Typography>
          <Button variant="secondary" icon={LogoutIcon} href={ROUTES.LOGOUT}>
            {L.NAV_ACCOUNT_LOGOUT}
          </Button>
        </Rhythm>

        <TabNavigation>
          <TabLink
            data-testid="tab-heading-me"
            to={generatePath(ROUTES.SETTINGS_MY_ACCOUNT_ORGID, { orgUuid })}
          >
            {L.SETTINGS_TAB_ME}
          </TabLink>
          <AccessControl
            data-testid="tab-heading-account"
            level={ACCESS_LEVELS.ADMIN}
          >
            <TabLink
              to={generatePath(ROUTES.SETTINGS_ACCOUNT_ORGID, { orgUuid })}
            >
              {L.SETTINGS_TAB_ACCOUNT}
            </TabLink>
          </AccessControl>
          <AccessControl level={ACCESS_LEVELS.ADMIN}>
            <TabLink
              data-testid="tab-heading-users"
              to={generatePath(ROUTES.SETTINGS_USERS_ORGID, { orgUuid })}
            >
              {L.SETTINGS_TAB_USERS}
            </TabLink>
          </AccessControl>
        </TabNavigation>
        <Switch>
          <Route component={AccountView} path={ROUTES.SETTINGS_ACCOUNT_ORGID} />
          <Route component={UsersView} path={ROUTES.SETTINGS_USERS_ORGID} />
          <Route
            component={ProfileView}
            path={ROUTES.SETTINGS_MY_ACCOUNT_ORGID}
          />
        </Switch>
      </Container>
    </Layout>
  );
};

export default SettingsView;
